import { Component, h, Prop, Element } from '@stencil/core';
/**
 * COMPNAME is for creating a container with a text as the primary focus with an attribution credited below.
 *
 * <em>For More Information:</em>
 * AEM Component- aafp-aem-library.git/ui.apps/src/main/content/jcr_root/apps/brand/aafp/components/content/aafp-quote
 * Sling Model- .aafp-aem-library.core.src.main.java.org.aafp.aem.core.models.AafpQuoteModel.java
 */
@Component({
  tag: 'aafp-quote',
  shadow: false,
})
export class AafpQuote {
  /**
   * For storing the Quote asset
   */
  @Prop() text!: string;
  /**
   * For storing the Attribution asset
   */
  @Prop() attribution: string;
  @Element() element: HTMLElement;

  render() {
    return (
      <div class="adl-quote">
        <blockquote class="adl-h1 adl-text-color--darkest adl-quote__blockquote">
          <p innerHTML={this.text} />
          <p class="adl-h3 adl-quote__footer" innerHTML={this.attribution} />
        </blockquote>
      </div>
    );
  }
}
